import React, { Component } from 'react'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { FontAwesomeIcon } from '../../../../CommonComponents/AssetsHelper';
export default class ConnectError extends Component {
    render() {
        const { msg , showMsg } = this.props;
        return (
            <div className="d-flex align-items-center">
                <div className="d-flex align-items-center reconnect200791">

                {showMsg ? <OverlayTrigger overlay={<Tooltip>{(msg && msg.length > 0) ? msg : `Feed disconnected as the social media account's user name got changed since your last connection with Taggbox. Kindly click on the button below to connect.`}</Tooltip>}>  
                    <div className="d-flex mx-2 align-items-center">
                        <span className="svg-icon svg-icon-secondary svg-icon-md">
                            <FontAwesomeIcon type={'regular'} icon={'circle-info'} iconClass={'text-gray-500'} />
                        </span>
                    </div>
                  </OverlayTrigger> : null}  

                    {!showMsg ? <OverlayTrigger overlay={<Tooltip>Click to resolve issue</Tooltip>}>

                        <a href="#" className="resetAction retry btn btn-danger btn-sm" title="">
                            <span className="reconnect_feed">
                                <FontAwesomeIcon type={'regular'} icon={'circle-info'} iconClass={'me-2'} />
                                Connect
                            </span>
                        </a>
                    </OverlayTrigger> : null}

                </div>
            </div>
        )
    }
}
